import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { AbuseReportsComponent } from './pages/abuse-reports/abuse-reports.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { HubReportsComponent } from './pages/hub-reports/hub-reports.component';
import { PromoCodesComponent } from './pages/promo-codes/promo-codes.component';
import { LoginLogsComponent } from './pages/login-logs/login-logs.component';
import { PageLayoutComponent } from './pages/page-layout/page-layout.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { UsersComponent } from './pages/users/users.component';
import { TestUsersComponent } from './pages/test-users/test-users.component';
import { PromoLogsComponent } from './pages/promo-logs/promo-logs.component';
import { HubComponent } from './pages/hub/hub.component';
import { SubscriptionsComponent } from './pages/subscriptions/subscriptions.component';
import { SubscriptionDetailComponent } from './pages/subscriptions/subscription-detail.component';
import { VisitorSessionsComponent } from './pages/visitor-sessions/visitor-sessions.component';
import { PlatformSettingsComponent } from './pages/platform-settings/platform-settings.component';
import { DeliveryPartnersComponent } from './pages/delivery-partners/delivery-partners.component';
import { DeliveryAssignmentsComponent } from './pages/delivery-assignments/delivery-assignments.component';
import { DeliveryFeeLedgerComponent } from './pages/delivery-fee-ledger/delivery-fee-ledger.component';
import { DeliveryHubNetworkComponent } from './pages/delivery-hub-network/delivery-hub-network.component';
import { DeliveryRatePolicyComponent } from './pages/delivery-rate-policy/delivery-rate-policy.component';
import { PortalOperatorsComponent } from './pages/portal-operators/portal-operators.component';
import { PortalPageGuard } from './guard/portal-page.guard';
import { TinyPromoCasesComponent } from './pages/tiny-promo/tiny-promo-cases.component';
import { TinyPromoCaseDetailComponent } from './pages/tiny-promo/tiny-promo-case-detail.component';
import { TinyPromoCommissionsComponent } from './pages/tiny-promo/tiny-promo-commissions.component';

const routes: Routes = [
  { path: '', redirectTo: '/sign-in', pathMatch: 'full' },
  { path: 'sign-in', component: SignInComponent },
  { 
    path: 'base', component: PageLayoutComponent, 
    canActivate: [AuthGuard], 
    children: [
      { path: 'dashboard', component: DashboardComponent, canActivate: [PortalPageGuard], data: { roles: ['ADMIN', 'OPS'] } },
      { path: 'users', component: UsersComponent, canActivate: [PortalPageGuard], data: { roles: ['ADMIN'] } },
      { path: 'portal-operators', component: PortalOperatorsComponent, canActivate: [PortalPageGuard], data: { roles: ['ADMIN'] } },
      { path: 'testusers', component: TestUsersComponent, canActivate: [PortalPageGuard], data: { roles: ['ADMIN'] } },
      { path: 'abuses', component: AbuseReportsComponent },
      { path: 'orders', component: HubReportsComponent },
      { path: 'hubs', component: HubComponent },
      { path: 'promos', component: PromoCodesComponent },
      { path: 'promocodelogs', component: PromoLogsComponent },
      { path: 'logs', component: LoginLogsComponent },
      { path: 'visitor-sessions', component: VisitorSessionsComponent },
      { path: 'subscriptions', component: SubscriptionsComponent },
      { path: 'subscriptions/:subscriptionId', component: SubscriptionDetailComponent },
      { path: 'platform-settings', component: PlatformSettingsComponent, canActivate: [PortalPageGuard], data: { roles: ['ADMIN'] } },
      { path: 'promo-managed-cases', component: TinyPromoCasesComponent, canActivate: [PortalPageGuard], data: { roles: ['ADMIN', 'TINYPROMO_OPS'] } },
      { path: 'promo-managed-cases/:caseId', component: TinyPromoCaseDetailComponent, canActivate: [PortalPageGuard], data: { roles: ['ADMIN', 'TINYPROMO_OPS'] } },
      { path: 'promo-commissions', component: TinyPromoCommissionsComponent, canActivate: [PortalPageGuard], data: { roles: ['ADMIN', 'TINYPROMO_OPS'] } },
      { path: 'delivery-partners', component: DeliveryPartnersComponent },
      { path: 'delivery-assignments', component: DeliveryAssignmentsComponent },
      { path: 'delivery-fee-ledger', component: DeliveryFeeLedgerComponent },
      { path: 'delivery-hub-network', component: DeliveryHubNetworkComponent },
      { path: 'delivery-rate-policy', component: DeliveryRatePolicyComponent },
    ] 
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
